import * as THREE from 'three';
import type { Vec3 } from '../api/types.js';

export interface FitCameraResult {
  pos: Vec3;
  lookAt: Vec3;
  fov: number;
}

// Pure helper testabile separato dall'adapter. Computes a sensible camera
// position to fit a Box3 in view, given a perspective FOV. Returns null if
// the box is empty or has zero extent.
export function fitCameraFromBox3(box: THREE.Box3, fov: number): FitCameraResult | null {
  if (box.isEmpty()) return null;
  const center = box.getCenter(new THREE.Vector3());
  const size = box.getSize(new THREE.Vector3());
  const maxDim = Math.max(size.x, size.y, size.z);
  if (maxDim <= 0) return null;
  const distance = maxDim / 2 / Math.tan((fov * Math.PI) / 360);
  // Position diagonal up + back from center for a 3/4 view that shows depth.
  const pos: Vec3 = [
    center.x + distance * 0.7,
    center.y + distance * 0.5,
    center.z + distance * 0.7,
  ];
  return {
    pos,
    lookAt: [center.x, center.y, center.z],
    fov,
  };
}
